export const MSG = {
  HOME: {
    TITLE: '젤다 사당지도',
  },
};
